import { Link } from "@tanstack/react-router";
import ARPLAN from "src/assets/ARPLAN.png";

import { Button } from "$/lib/components";
import { LogoutButton } from "$/lib/components/molecules/Navbar/NavbarSettingsDropdownMenu";
import CircledCheckMarkIcon from "$/lib/icons/CircledCheckMarkIcon";
import CrossCircleIcon from "$/lib/icons/CrossCircleIcon";
import WarningIcon from "$/lib/icons/DisconnectedWarningIcon";
import type { SubscriptionStatusEnum } from "$/lib/types/models/Subscription.types";
import { ROUTES } from "$/lib/utils/constants/routes.constants";

type Props = {
  status: SubscriptionStatusEnum | null | undefined;
};

const statusLabelMap: Record<SubscriptionStatusEnum, string> = {
  INCOMPLETE: "incomplet",
  INCOMPLETE_EXPIRED: "expiré",
  PAST_DUE: "en retard de paiement",
  UNPAID: "impayé",
  PAUSED: "en pause",
  TRIALING: "en période d'essai",
  ACTIVE: "actif",
  CANCELED: "annulé",
  CANCELLING: "en cours d'annulation",
};

const SubscriptionRequired = ({ status }: Props) => {
  const statusLabel = status
    ? (statusLabelMap[status] ?? "inactif")
    : "inactif";

  return (
    <div className="fixed inset-0 z-[60] flex h-screen w-full items-center justify-center overflow-hidden">
      {/* --- OVERLAY DE FLOU --- */}
      <div className="absolute inset-0 z-10 bg-primary/10 backdrop-blur-sm" />

      {/* --- MODULE --- */}
      <div className="z-20 flex w-[92vw] max-w-xl flex-col gap-4 rounded-2xl border border-border bg-white p-6 text-textColor shadow-sm screen850:w-[510px]">
        <div className="flex flex-col items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-warning/10 text-warning">
            <WarningIcon className="h-12 w-12" />
          </div>
          <div className="flex flex-col items-center gap-4">
            <h1 className="text-lg font-bold">Abonnement requis</h1>
            <div className="flex !w-[204px] flex-row items-center justify-center gap-2 rounded-lg border-2 border-border px-3 py-2">
              <p className="text-sm font-medium font-semibold text-textColor">
                Statut actuel : {statusLabel}
              </p>
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF4B67] bg-opacity-10">
                <CrossCircleIcon className="text-[#FF4B67]" />
              </div>
            </div>
            <p className="text-justify text-sm font-semibold text-textColor">
              L'accès à cette page est réservé aux utilisateurs disposant d'un
              abonnement actif. Mettez à jour votre abonnement pour continuer à
              utiliser toutes les fonctionnalités.
            </p>
          </div>
        </div>
        <div className="flex w-full flex-col items-center justify-center gap-2">
          <div className="flex flex-col items-center gap-2 screen850:flex-row screen850:gap-4">
            <LogoutButton
              className="h-[36px] !w-[160px] bg-info text-sm font-medium text-textInfo"
              iconClassName=" hidden text-textInfo"
            />
            <Link to={ROUTES.SUBSCRIPTION}>
              <Button className="!w-[160px] bg-primary text-sm font-medium text-white hover:bg-primary/90">
                S'abonner
              </Button>
            </Link>
          </div>
          <Link to={ROUTES.USER_INFO}>
            <Button className="!bg-white !p-0 text-xs font-semibold text-primary underline hover:opacity-80 hover:shadow-none">
              Gérer mon compte
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionRequired;
